import React from 'react';

const TableDisplay = (props)=>{
    return(<>
        <table className="table table-striped">
            <thead>
                <tr key='0'>
                {props.tableHeading.map((heading, i)=>{
                    return(<th key = {i} scope='col'>{heading}</th>);
                })
                }
                </tr>
            </thead>
            <tbody>{props.tableData}</tbody>
            
        </table>
    </>)
}

export default TableDisplay;
